import { render, staticRenderFns } from "./ReciveAddrsEdit.vue?vue&type=template&id=12a3c645&scoped=true&"
import script from "./ReciveAddrsEdit.vue?vue&type=script&lang=js&"
export * from "./ReciveAddrsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReciveAddrsEdit.vue?vue&type=style&index=0&id=12a3c645&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a3c645",
  null
  
)

export default component.exports